import './BreadcrumbsBar.css'
import { Link } from 'react-router-dom'

type BreadcrumbLinkProps = {
  label: string
  to: string
}

function BreadcrumbDividerIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 16V8L15 12L10 16Z" fill="currentColor" />
    </svg>
  )
}

function BreadcrumbLink({ label, to }: BreadcrumbLinkProps) {
  if (to) {
    return (
      <div className="breadcrumb-link-container">
        <Link className="breadcrumb-link" to={to}>
          {label}
        </Link>
        <BreadcrumbDividerIcon className="breadcrumb-divider" />
      </div>
    )
  }
  return <span className="breadcrumb-current">{label}</span>
}

type BreadcrumbsBarProps = {
  links: {
    label: string
    to: string
    isActive?: boolean
  }[]
}

export function BreadcrumbsBar({ links }: BreadcrumbsBarProps) {
  return (
    <div className="breadcrumbs-bar">
      {links.map(link => {
        return <BreadcrumbLink key={link.label} label={link.label} to={link.to} />
      })}
    </div>
  )
}
